import React from 'react';
export function ProfilePlaceholderIcon() {
    return (React.createElement("svg", { fill: "none", viewBox: "0 0 24 24" },
        React.createElement("path", { fill: "var(--primary)", stroke: "var(--primary)", strokeWidth: ".5", d: "M11.738 13.571c4.142 0 7.5 1.567 7.5 3.5v2.5h-15v-2.5c0-1.933 3.358-3.5 7.5-3.5Zm6.5 3.5c0-1.38-2.91-2.5-6.5-2.5s-6.5 1.12-6.5 2.5v1.5h13v-1.5Zm-6.5-12.5a3.5 3.5 0 1 1 0 7 3.5 3.5 0 0 1 0-7Zm0 1a2.5 2.5 0 1 0 0 5 2.5 2.5 0 0 0 0-5Z" })));
}
